import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import AddButtonInTopBar from "../components/AddButtonInTopBar";
import BreadCrumb from "../components/breadCrumb";
import DataGrid from "../components/common/DataGrid";
import PageContent from "../components/pageContent";
import TopBarWithBreadCrumb from "../components/TopBarWithBreadCrumb";
import { FormatString } from "../helpers/stringHelpers";
import { checkCrud } from "../helpers/userRolesHelper";
import DeletePopup from "../popups/DeletePopup";
import SampleCardPopup from "../popups/SampleCardPopup";
import { TranslationProvider } from "../providers/TranslationContext";
import { addNotification } from "../redux/actions";
import { apiGetAllSampleCards, apiGetSampleCardDetail, apiDeleteSampleCard } from "../services/SampleCardsService";

interface Props {
  contextLevel: string;
}

const entityName = 'sampleCard';
const translationPrefix = 'Samplecards';
const translationModel = { prefix: translationPrefix };

const VzorkovnicePage = (props: Props) => {
  const { t } = useTranslation(undefined, { keyPrefix: translationPrefix });
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({ rows: [] });
  const [sampleCardPopupData, setSampleCardPopupData] = useState({
    visible: false,
    id: undefined
  });
  const [deleteSampleCartPopup, setDeleteSampleCardPopup] = useState({
    visible: false,
    id: undefined
  });
  const dispatch = useDispatch();

  const [canCreate, setCanCreate] = useState(false);
  const [canRead, setCanRead] = useState(false);
  const [canUpdate, setCanUpdate] = useState(false);
  const [canDelete, setCanDelete] = useState(false);

  const userInfo = useSelector((state: any) => state.userInfo);

  const setRoles = () => {
    setCanCreate(checkCrud(entityName, 'create', userInfo));
    setCanRead(checkCrud(entityName, 'read', userInfo));
    setCanUpdate(checkCrud(entityName, 'update', userInfo));
    setCanDelete(checkCrud(entityName, 'delete', userInfo));
  }

  useEffect(() => {
    setRoles();
  }, [userInfo.UserRoles])

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    apiGetAllSampleCards().then((responseData) => {
      setData({
        rows: responseData.data,
      });
      setLoading(false);
    });
  };

  const handleDeleteRow = (row) => {
    apiDeleteSampleCard(row.id)
      .then((responseData) => {
        dispatch(addNotification({ text: FormatString(t('Popup.DeleteSuccess'), row.name), type: 'success' }));
        loadData();

        setLoading(false);
      })
      .catch(() => {
        dispatch(addNotification({ text: FormatString(t('Popup.DeleteFailure'), row.name), type: 'error' }));
      });
  }

  return (
    <TranslationProvider value={translationModel}>
      {sampleCardPopupData.visible && (
        <SampleCardPopup
          id={sampleCardPopupData.id}
          canOnlyEditSortOrder={!canUpdate}
          sampleCards={data.rows}
          refreshData={() => {
            loadData();
          }}
          handleCancel={() => {
            setSampleCardPopupData({ visible: false, id: undefined });
          }}
        />
      )}
      {/* {deleteSampleCartPopup.visible && (
        <DeletePopup
          id={deleteSampleCartPopup.id}
          refreshData={() => loadData()}
          handleCancel={() => {
            setDeleteSampleCardPopup({ visible: false, id: undefined });
          }}
          getDataApiAction={apiGetSampleCardDetail}
          deleteApiAction={apiDeleteSampleCard}
          pageName={"vzorkovnice"}
        />
      )} */}
      <TopBarWithBreadCrumb
        contextLevel={props.contextLevel}
        pageLevel={t('Label')}
        rightAreaComponent={
          <AddButtonInTopBar
            setPopupData={setSampleCardPopupData}
            text={t('CreateText')}
            enabled={canCreate}
          />
        }
      />

      <PageContent>
        <DataGrid
          loading={loading}
          rows={data.rows}
          showDeleteButton={canDelete}
          showEditButton={canRead}
          onDeleteRow={handleDeleteRow}
          handleEditAction={(id: any) => {
            setSampleCardPopupData({ visible: true, id: id });
          }}
          handleDeleteAction={(id: any) => {
            setDeleteSampleCardPopup({ visible: true, id: id });
          }}
          cols={[
            { name: t('sortOrder'), dataField: "sortOrder", sortable: true },
            { name: t('name'), dataField: "name", sortable: true, filterable: true, filterType: "text" },
            { name: t('noteInternal'), dataField: "noteInternal", sortable: false, filterable: false },
            { name: t('modifiedOn'), fieldType: "datetime", dataField: "modifiedOn", sortable: true },
            { name: t('createdOn'), fieldType: "datetime", dataField: "createdOn", sortable: true }
          ]}
        />
      </PageContent>
    </TranslationProvider>
  );
};

export default VzorkovnicePage;

